<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="orderhistory_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        id="Path_1384"
        data-name="Path 1384"
        d="M15,3V5"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1385"
        data-name="Path 1385"
        d="M7,3V5"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1386"
        data-name="Path 1386"
        d="M3,9H19"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1387"
        data-name="Path 1387"
        d="M19,10V7a3,3,0,0,0-3-3H6A3,3,0,0,0,3,7v9a3,3,0,0,0,3,3h4"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1388"
        data-name="Path 1388"
        d="M17.393,15.983v1.758l1.382.843"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1389"
        data-name="Path 1389"
        d="M17.5,22A4.5,4.5,0,0,1,13,17.5,4.569,4.569,0,0,1,17.5,13a4.5,4.5,0,0,1,0,9"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
